import { createRoute, useEntityUrl } from 'framework/routing';
import { useParams } from 'react-router-dom';

export const SKILL_BASED_QUEUE_PATH = '/skill-based-queues';

export const useSkillBasedQueueRoute = () => {
  const routers = createRoute({ listRoute: SKILL_BASED_QUEUE_PATH });

  return {
    ...routers,
    copyEntityRoute: `${routers.singleEntityRoute}/copy`,
  };
};

export const useSkillBasedQueueUrl = () => {
  const { getSingleEntityUrl, ...restUrls } = useEntityUrl({
    baseLink: SKILL_BASED_QUEUE_PATH,
  });
  const getCopyEntityUrl = (id: StringOrNumber): string => `${getSingleEntityUrl(id)}/copy`;

  return {
    ...restUrls,
    getSingleEntityUrl,
    getCopyEntityUrl,
  };
};

export const useSkillBasedQueueId = () => {
  const { id } = useParams<Dictionary<string>>();

  return id!;
};
